import { ToastPosition } from "react-toastify";

export const snackbarPositions = [
  "top-left",
  "top-center",
  "top-right",
  "bottom-left",
  "bottom-center",
  "bottom-right",
] as const satisfies Readonly<ToastPosition[]>;

export type SnackbarPosition = (typeof snackbarPositions)[number];
